import React from "react";
import HeaderOne from "./HeaderOne";
import FooterOne from "./FooterOne";

const PrivacyPolicy = () => {
  document.title = "Privacy Policy | MordenBazaar";

  return (
    <>
      <HeaderOne />

      <div className="page-content pt-0">
        <div className="container py-5">
          <div className="row justify-content-center">
            <div className="col-12 col-lg-9 col-xl-8">

              <h1 className="mt-4 mb-4">Privacy Policy</h1>

              {/* INTRO */}
              <ul className="list-disc pl-5 mb-5 space-y-2">
                <li>This policy explains how MordenBazaar collects, uses, and protects your personal information.</li>
                <li>Your privacy is important to us, and we are committed to safeguarding your data.</li>
              </ul>

              {/* 1 */}
              <h2 className="mt-5 mb-3">1. Information We Collect</h2>
              <ul className="list-disc pl-5 mb-4 space-y-2">
                <li>Personal details such as name, email address, and phone number</li>
                <li>Shipping and billing addresses</li>
                <li>Order details and purchase history</li>
                <li>Login credentials such as email and encrypted password</li>
                <li>Device information, IP address, cookies, and usage data</li>
              </ul>

              {/* 2 */}
              <h2 className="mt-5 mb-3">2. How We Use Your Information</h2>
              <ul className="list-disc pl-5 mb-4 space-y-2">
                <li>To create, maintain, and manage your account</li>
                <li>To process orders, payments, and deliveries</li>
                <li>To send order updates, service notifications, and promotional messages</li>
                <li>To improve website functionality and performance</li>
                <li>To provide personalized product recommendations</li>
              </ul>

              {/* 3 */}
              <h2 className="mt-5 mb-3">3. Cookies & Tracking Technologies</h2>
              <ul className="list-disc pl-5 mb-4 space-y-2">
                <li>Cookies are used to enhance your browsing experience.</li>
                <li>They help us analyze traffic and remember your preferences.</li>
                <li>You may disable cookies from your browser settings if you prefer.</li>
              </ul>

              {/* 4 */}
              <h2 className="mt-5 mb-3">4. Third-Party Data Sharing</h2>
              <ul className="list-disc pl-5 mb-4 space-y-2">
                <li>Delivery and logistics partners</li>
                <li>Payment gateway providers</li>
                <li>Analytics and marketing platforms such as Google and Meta</li>
                <li>We do <strong>not</strong> sell or rent your personal data to any third party</li>
              </ul>

              {/* 5 */}
              <h2 className="mt-5 mb-3">5. Your Rights</h2>
              <ul className="list-disc pl-5 mb-4 space-y-2">
                <li>Access the personal data we hold about you</li>
                <li>Update or correct inaccurate information</li>
                <li>Request deletion of your data (subject to legal obligations)</li>
                <li>Unsubscribe from promotional communications at any time</li>
              </ul>

              {/* 6 */}
              <h2 className="mt-5 mb-3">6. Data Security</h2>
              <ul className="list-disc pl-5 mb-4 space-y-2">
                <li>We implement appropriate security measures to protect your data.</li>
                <li>Access to personal data is restricted to authorized personnel only.</li>
                <li>Despite safeguards, no system is 100% secure.</li>
              </ul>

              {/* 7 */}
              <h2 className="mt-5 mb-3">7. Policy Updates</h2>
              <ul className="list-disc pl-5 mb-4 space-y-2">
                <li>This Privacy Policy may be updated from time to time.</li>
                <li>Significant changes will be communicated through the website.</li>
                <li>Continued use of the platform implies acceptance of updated terms.</li>
              </ul>

              {/* CONTACT */}
              <h2 className="mt-5 mb-3">8. Contact Us</h2>
              <ul className="list-disc pl-5 mb-5 space-y-2">
                <li><strong>Email:</strong> support@mordenbazaar.com</li>
              </ul>

            </div>
          </div>
        </div>
      </div>

      <FooterOne />
    </>
  );
};

export default PrivacyPolicy;